module.exports = __webpack_public_path__ + "catalog/items/teaching-post/teaching-post.png";